import { ErrorBoundary } from "@repo/app-shell"
import type { Id } from "@repo/db"
import { Button } from "@repo/shad/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@repo/shad/ui/dropdown-menu"
import { EditorWithPageManager } from "@repo/website-builder"
import { createFileRoute, useRouteContext } from "@tanstack/react-router"
import { ChevronDown } from "lucide-react"
import { useState } from "react"

import { WebsiteThemeSelector } from "@/components/website/website-theme-selector"

export const Route = createFileRoute("/$dealership/website")({
  staticData: {
    breadcrumb: "Website",
  },
  component: RouteComponent,
})

function RouteComponent() {
  const context = useRouteContext({ from: "/$dealership" })
  const stores =
    context && typeof context === "object" && "stores" in context ? context.stores : null
  const dealership =
    context && typeof context === "object" && "dealership" in context ? context.dealership : null
  const [selectedStoreId, setSelectedStoreId] = useState<Id<"stores"> | undefined>(stores?.[0]?._id)

  if (!stores || stores.length === 0) {
    return <div>No stores found</div>
  }

  const selectedStore = stores.find((store: any) => store._id === selectedStoreId) || stores[0]

  const websiteHeaderActions = (
    <>
      {stores.length > 1 && selectedStore ? (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className="min-w-[160px] justify-between">
              {selectedStore.name}
              <ChevronDown className="ml-2 h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-[200px]">
            {stores.map((store: any) => (
              <DropdownMenuItem
                key={store._id}
                onClick={() => setSelectedStoreId(store._id)}
                className="cursor-pointer"
              >
                {store.name}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      ) : null}
      {dealership?._id ? (
        <WebsiteThemeSelector dealershipId={dealership._id as Id<"dealerships">} />
      ) : null}
    </>
  )

  return (
    <div className="puck">
      <ErrorBoundary>
        {selectedStoreId ? (
          <EditorWithPageManager
            organizationId={dealership?._id || ("" as Id<"dealerships">)}
            storeId={selectedStoreId}
            headerActions={websiteHeaderActions}
          />
        ) : (
          <div className="flex items-center justify-center h-96 text-muted-foreground">
            Please select a store
          </div>
        )}
      </ErrorBoundary>
    </div>
  )
}
